export default __webpack_public_path__ + "static/media/il-main.47975b79.svg";